module.exports = __webpack_public_path__ + "img/广东石油化工学院.b408af01.png";